export const DISPATCH_REFERENCE_HEADERS = ['brand', 'product', 'category', 'quantity', 'units'];
export const DISPATCH_STOCK_HEADERS = ['inventory_product_id', 'no_of_units', 'margin_percent', 'notes', ...DISPATCH_REFERENCE_HEADERS];

const firstValue = (...values) => values.find(value => value !== undefined && value !== null && value !== '') ?? '';

export const buildStockDispatchRows = (products, warehouseId, getProductName) => products
  .filter(item => String(item.warehouse_id) === String(warehouseId)
    && item.id != null && item.is_active !== false && item.product_barcode_id && item.exp_date
    && Number.isFinite(Number(item.no_of_units || item.count_in_stock || 0))
    && Number(item.no_of_units || item.count_in_stock || 0) > 0)
  .map(item => ({
    inventory_product_id: item.id,
    no_of_units: Number(item.no_of_units || item.count_in_stock || 0),
    margin_percent: '',
    brand: firstValue(item.brand_name_english, item.brand_name, item.brand, item.brandName, item.brand_name_telugu),
    product: firstValue(item.product_name, item.product_name_eng, item.product_name_tel, item.productName, item.name, getProductName(item)),
    category: firstValue(item.category_name_english, item.category_name, item.categoryName, item.category_name_telugu),
    quantity: firstValue(item.quantity, item.catalogQuantity, item.barcode_quantity),
    units: firstValue(item.unit_short_code, item.unit_name, item.units, item.unit),
    notes: [getProductName(item), item.sku_id ? `SKU: ${item.sku_id}` : '',
      (item.bar_code || item.mk_barcode) ? `Barcode: ${item.bar_code || item.mk_barcode}` : '',
      `Expiry: ${String(item.exp_date).split('T')[0]}`].filter(Boolean).join(' | '),
  }));
